import React, { createContext, useState, useContext, useEffect } from 'react';
import { AuthContext } from './AuthContext';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const { token } = useContext(AuthContext);
    const [cartItems, setCartItems] = useState(() => {
        const savedCart = localStorage.getItem('cart');
        return savedCart ? JSON.parse(savedCart) : [];
    });

    // Sync with localStorage
    useEffect(() => {
        localStorage.setItem('cart', JSON.stringify(cartItems));
    }, [cartItems]);

    // Clear cart on logout
    useEffect(() => {
        if (!token) {
            setCartItems([]);
        }
    }, [token]);

    const addToCart = (car) => {
        setCartItems((prevItems) => {
            const exists = prevItems.find((item) => item.id === car.id);
            if (exists) return prevItems;
            return [...prevItems, car];
        });
    };

    const removeFromCart = (carId) => {
        setCartItems((prevItems) => prevItems.filter((item) => item.id !== carId));
    };

    const clearCart = () => {
        setCartItems([]);
    };

    const isInCart = (carId) => {
        return cartItems.some((item) => item.id === carId);
    };

    return (
        <CartContext.Provider value={{ cartItems, addToCart, removeFromCart, clearCart, isInCart }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => {
    const context = useContext(CartContext);
    if (!context) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
};
